import { useMemo } from "react";
import { SubscriberEntryPoint, SubscriptionType, UpsellPanelContent, UserAccessLevelType } from "../../../constants/upsellPanelEnumsAndConstants";
import { useRouteInitialData } from "../../../hooks/useRouteInitialData";
import useUpsellBaseModel from "./useUpsellBaseModel";

const useFreeInsightsPopupModel = (overrideDownloadFileId) => {
    const { popupMustLogin, entryPoint, timeToInitialDisplay, requiredAccessLevel, productHandle } = useRouteInitialData();

    const baseModel = useUpsellBaseModel();
    const content = {
        ...baseModel.content,
        contentParagraph1: UpsellPanelContent.CREATE_FREE_ACCOUNT
    };
    const downloadFileId = overrideDownloadFileId ?? baseModel.downloadFileId;
    const model = useMemo(() => {
        return {
            ...baseModel,
            byPassPhoneVerification: true,
            content,
            displayErrorPanel: false,
            displayQuestionAllSteps: true,
            displayUpsellFooter: false,
            downloadFileId,
            entryPoint: entryPoint ?? SubscriberEntryPoint.FREE_ARTICLE,
            hideCloseButton: false,
            hideEmailModal: true,
            hideSignup: true,
            hideSkipPaymentBtn: true,
            mainButtonText: UpsellPanelContent.CREATE_YOUR_FREE_ACCOUNT,
            mobileRequired: false,
            noLoginText: true,
            outerClass: UpsellPanelContent.UPSELL_PANEL_FULL_WIDTH_CSS_CLASS,
            passwordRequired: true,
            popupMustLogin: popupMustLogin,
            productHandle: productHandle ?? SubscriptionType.SUBSCRIPTION_INSIGHTS_FREE_PRODUCT_HANDLE,
            panelClass: UpsellPanelContent.TEXT_WHITE_CSS_CLASS,
            requiredAccessLevel: requiredAccessLevel ?? UserAccessLevelType.IntelligentInvestor,
            secondaryButtonsVertical: false,
            timeToInitialDisplay: timeToInitialDisplay ?? 8000,
            usePopupOverlay: true,
            usePopupOverlayV2: true,
        };
    }, []);

    return model;
};
export default useFreeInsightsPopupModel;
